import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { VenderJson } from "../../../DynamicFormsJson/MastersJSON/vender";
import { getVender } from "../../../Slice/vender.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import { venderColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet, apiPost } from "../../../utils/api_service";
import { noInternetMsg, statusmsg } from "../../../config/messageconstant";
class VenderList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {},
    };
  }

  onChangeStatus = (rowData) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      let status = "";
      if (rowData.isActive == 0) {
        status = 1;
      } else {
        status = 0;
      }
      showLoador({ loador: true });
      apiPost({
        url:
          endpoint.vender +
          "/update-is-active?id=" +
          rowData.id +
          "&status=" +
          status,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: statusmsg });
          window.location.reload();
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { venderList, getVender } = this.props;
    const { dynamicMasterData } = this.state;
    return (
      <>
        <DynamicMainScreen
          dynamicMasterData={dynamicMasterData}
          formPath={VenderJson.formPath}
          screenTitle={VenderJson.screenTitle}
          showPdfDownload={false}
          showExcelDownload={false}
          showExtension={false}
          pdfFileName={false}
          showAddButton={VenderJson.showAddButton}
          tableColumnsToFilter={VenderJson.tableColumnsToFilter}
          tableColumns={venderColumns}
          tableData={venderList?.vender}
          getTableData={getVender}
          getTableDataById={true}
          apiBaseURL={VenderJson.apiBaseURL}
          baseIdColumn={VenderJson.baseIdColumn}
          showDeleteIcon={true}
          isActiveURLFalse={true}
          isActiveURLFalseMethod={this.onChangeStatus}
          showViewButtonInTable={true}
          formPathView={VenderJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  venderList: state.vender,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getVender,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(VenderList);
